$(document).ready(function() {
    $('.ttgAnsprechpartnerErgebnisListeKategorien .panel-heading').click(function() {
        if (!$(this).children('a').hasClass('in')) {
            $(this).children('h3 span').toggleClass('arrowUp');
        }
    });

    $('.ttgAnsprechpartnerPrintButton').click(function() {
        setTimeout(function() {
            window.print();
        }, 100);
    });

    $('.ttgAnsprechpartnerItemContainer, .ttgAnsprechpartnerErgebnisListe').on('mouseenter', '.ttgAnsprechpartnerItem', function() {
        $(this).find('.ansprechpartner-bild-container').addClass('flipped');
    });

    $('.ttgAnsprechpartnerItemContainer, .ttgAnsprechpartnerErgebnisListe').on('mouseleave', '.ttgAnsprechpartnerItem', function() {
        $(this).find('.ansprechpartner-bild-container').removeClass('flipped');
    });

    $('.ttgAnsprechpartnerItemContainer').on('touchstart', '.ttgAnsprechpartnerItem', function() {

        // bei allen Elementen d-none entfernen und d-block hinzufügen
        $('.ansprechpartner-bild-container span.interaction-indicator').removeClass('d-none').addClass('d-block');

        // nur bei dem aktuellen Element d-none hinzufügen und d-block entfernen
        $(this).find('.ansprechpartner-bild-container span.interaction-indicator').removeClass('d-block').addClass('d-none');

    });
});

